import React from 'react';
import { CaseInfoHeader, CaseInfoHeaderFields } from '../../../../../shared/case-info-header/case-info-header';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { useQuery } from '@apollo/client';
import { CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryDocument } from '../../../../../../generated';

interface HeaderSummaryContainerProps {
  caseId: string;
}

export const HeaderSummaryContainer: React.FC<HeaderSummaryContainerProps> = (props) => {
  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError
  } = useQuery(CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryDocument, {
    variables: {
      archivedIdentityVerificationCaseSummaryId: props?.caseId
    }
  });

  const caseInfoData: CaseInfoHeaderFields = {
    applicant: {
      displayName: applicantDetailData?.archivedIdentityVerificationCaseSummary?.applicant?.displayName ?? '',
      id: applicantDetailData?.archivedIdentityVerificationCaseSummary?.applicant?.id ?? ''
    },
    submittedAt: applicantDetailData?.archivedIdentityVerificationCaseSummary?.submittedAt ?? '',
    lastActivityAt: applicantDetailData?.archivedIdentityVerificationCaseSummary?.lastActivityAt ?? '',
    id: applicantDetailData?.archivedIdentityVerificationCaseSummary?.id
  };

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading}
      hasData={applicantDetailData}
      error={applicantDetailError}
      hasDataComponent={<CaseInfoHeader data={caseInfoData} caseType="identityVerification" />}
    />
  );
};
